import { atom } from 'jotai';

import type { FaultedDevice } from '@/features/equipment-browser/faulted-devices/faulted-devices.types';
import { toModeValue } from '@/features/equipment-browser/manual-devices/manual-devices.utils';
import { readRefAtomValue } from '@/readings-settings/use-get-ref-value';

import type { ModeValuesByDeviceId } from '../reset-faulted.types';

/**
 * Live current mode of each device with a mode dropdown, read from its value ref.
 * Modeless devices are left out.
 *
 * Update Cascade:
 * a device's mode setting changes
 *  -> its entry is re-read
 */
export function createCurrentModesAtom(devices: FaultedDevice[]) {
  const currentModesAtom = atom<ModeValuesByDeviceId>((get) =>
    Object.fromEntries(
      devices.flatMap((device) => {
        const valueRef = device.modeDropdown?.valueRef;
        if (!valueRef) return [];
        return [[device.summary.referenceId, toModeValue(readRefAtomValue(get, valueRef))]];
      })
    )
  );
  currentModesAtom.debugLabel = 'ResetFaultedState.CurrentModes';
  return currentModesAtom;
}
